import { Minus, Plus, X } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useCart } from '../context/CartContext'
import { formatMoney } from '../lib/format'
import { productImageUrl } from '../lib/images'

export function CartDrawer() {
  const cart = useCart()
  return (
    <div className={`drawer-backdrop ${cart.isOpen ? 'is-open' : ''}`} onMouseDown={e => e.target === e.currentTarget && cart.setOpen(false)}>
      <aside className="cart-drawer">
        <div className="drawer-header"><h2>MINHA SACOLA</h2><button className="icon-button" onClick={() => cart.setOpen(false)}><X /></button></div>
        {cart.items.length === 0 ? (
          <div className="empty-state"><p>Sua sacola está vazia.</p><Link className="text-link" to="/produtos" onClick={() => cart.setOpen(false)}>EXPLORAR PRODUTOS</Link></div>
        ) : cart.quoteLoading && !cart.quote ? (
          <div className="page-message">Validando sacola...</div>
        ) : cart.quoteError ? (
          <div className="empty-state"><p>{cart.quoteError}</p><button className="text-link" onClick={() => void cart.refreshQuote()}>TENTAR NOVAMENTE</button></div>
        ) : cart.quote ? (
          <>
            <div className="cart-items">
              {cart.quote.items.map(item => (
                <div className="cart-item" key={item.variant_id}>
                  <Link to={`/produto/${item.slug}`} onClick={() => cart.setOpen(false)} className="cart-item__image">
                    {item.primary_image_path ? <img src={productImageUrl(item.primary_image_path)} alt={item.product_name} /> : <div className="image-placeholder">GK</div>}
                  </Link>
                  <div className="cart-item__content">
                    <strong>{item.product_name}</strong>
                    <span>{item.color_name} · {item.size}</span>
                    <span>{formatMoney(item.unit_price)}</span>
                    {!item.available && <span className="stock-warning">Quantidade indisponível</span>}
                    <div className="qty-control">
                      <button onClick={() => cart.updateQuantity(item.variant_id, item.quantity - 1)}><Minus size={14} /></button>
                      <span>{item.quantity}</span>
                      <button onClick={() => cart.updateQuantity(item.variant_id, item.quantity + 1)}><Plus size={14} /></button>
                    </div>
                    <button className="link-button" onClick={() => cart.remove(item.variant_id)}>REMOVER</button>
                  </div>
                </div>
              ))}
            </div>
            <div className="cart-summary">
              <div><span>Subtotal</span><strong>{formatMoney(cart.quote.subtotal)}</strong></div>
              {cart.quote.shipping_amount > 0 && <div><span>Frete</span><strong>{formatMoney(cart.quote.shipping_amount)}</strong></div>}
              <small>Retirada grátis na GK Maison, Sala 3, Sumaré/SP. A taxa da forma de pagamento será informada separadamente no checkout, antes de confirmar o pedido.</small>
              {cart.quote.can_checkout
                ? <Link to="/checkout" className="button button--dark button--full" onClick={() => cart.setOpen(false)}>FINALIZAR PEDIDO</Link>
                : <button className="button button--dark button--full" disabled>REVISE A SACOLA</button>}
            </div>
          </>
        ) : null}
      </aside>
    </div>
  )
}
